import {
  ChangeDetectionStrategy,
  Component,
  Input,
  input,
} from '@angular/core';

@Component({
  selector: 'wilson-page-frame-v2',
  templateUrl: './page-frame-v2.component.html',
  styleUrls: ['./page-frame-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  host: {
    '[class.fill-height-host]': 'fillHeight()',
  },
})
export class PageFrameV2Component {
  @Input() renderHeader = true;
  @Input() customHeader = false;
  @Input() stickyHeader = false;

  /** Stretches the frame to its container's height so only mainContent's grid scrolls internally; header/toolbar stay pinned. Default false = current behavior, unchanged for existing consumers. */
  readonly fillHeight = input(false);
}
